import { ReactNode, useEffect, useState } from 'react';

import Header from './Header';
import SidebarCollapsible from './SidebarCollapsible';
import { SIDEBAR_WIDTH, SIDEBAR_BREAKPOINT_WIDTH } from './sidebarConstants';

export default function Layout({ children }: { children: ReactNode }) {
  // Read from localStorage, default to false if not set
  const getInitialCollapsed = () => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem('sidebar-collapsed');
      return stored === 'true';
    }
    return false;
  };
  const [isCollapsed, setIsCollapsed] = useState(getInitialCollapsed);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const sidebarWidth = isCollapsed
    ? SIDEBAR_WIDTH.COLLAPSED
    : windowWidth <= SIDEBAR_BREAKPOINT_WIDTH
      ? SIDEBAR_WIDTH.EXPANDED_SMALL
      : SIDEBAR_WIDTH.EXPANDED_LARGE;

  useEffect(() => {
    document.documentElement.style.setProperty('--sidebar-width', sidebarWidth);
    return () => {
      document.documentElement.style.removeProperty('--sidebar-width');
    };
  }, [sidebarWidth]);

  // Collapse sidebar if screen width is less than breakpoint
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth <= SIDEBAR_BREAKPOINT_WIDTH) {
        setIsCollapsed(true);
        localStorage.setItem('sidebar-collapsed', 'true');
      }
      // else {
      //   setIsCollapsed(false);
      //   localStorage.setItem('sidebar-collapsed', 'false');
      // }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSetIsCollapsed = (collapsed: boolean) => {
    setIsCollapsed(collapsed);
    localStorage.setItem('sidebar-collapsed', collapsed ? 'true' : 'false');
  };

  return (
    <div className="h-full w-full flex relative">
      {/* Fixed sidebar */}
      <div className="fixed h-full z-40" style={{ width: sidebarWidth }}>
        <SidebarCollapsible
          isCollapsed={isCollapsed}
          setIsCollapsed={handleSetIsCollapsed}
          windowWidth={windowWidth}
        />
      </div>

      {/* Content area with proper scrollbar position */}
      <div
        className="h-full flex flex-col"
        style={{
          width: `calc(100% - ${sidebarWidth})`,
          marginLeft: sidebarWidth,
          transition: 'margin-left 300ms, width 300ms',
        }}
      >
        {/* Fixed header */}
        <div
          className="fixed z-20"
          style={{
            left: sidebarWidth,
            right: 0,
            transition: 'left 300ms',
          }}
        >
          <Header sidebarWidth={sidebarWidth} />
        </div>

        {/* Header spacer */}
        <div className="min-h-[60px] xl:min-h-[64px]  4xl:min-h-[96px] "></div>

        {/* Scrollable content */}
        <div className="flex-1 overflow-x-auto overflow-y-auto">
          {/* Content with minimum width */}
          <div className="flex-1 flex flex-col h-full bg-white">
            <div className="flex-1 flex flex-col min-h-0 min-w-[1124px]">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
